import React, { useEffect, useState } from "react";
import Page from "../pages/Page";
import PageContentWrapper from "./PageContentWrapper";
import TabularListing from "./TabularListing";
import TabularListingHeader from "./TabularListingHeader";
import TabularListingFooter from "./TabularListingFooter";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "react-bootstrap";
import {
  updateQueryParams,
  sortUpdated,
  searchUpdated,
  perPageUpdated,
  pageUpdated,
  selectQueryParams,
} from "../ui/customerListingReducer";
import { toast } from "react-toastify";

const ListingPageComponent = (props) => {
  const [listingApi] = props.listingMutation;
  const [records, setRecords] = useState([]);
  const [paginationMeta, setPaginationMeta] = useState([]);
  const queryParams = useSelector(selectQueryParams);
  const { sort_by, sort_order, page, per_page } = queryParams;
  const dispatch = useDispatch();
  const defaultHeaderConfig = { disableSort: false };

  useEffect(() => {
    getRecords({ ...queryParams, ...props.params, filters: {...props.filtersModel} });
  }, [queryParams]);

  const getRecords = async (params = {}) => {
    try {
      let response = await listingApi(params).unwrap();
      setPaginationMeta(response.meta.pagination);
      setRecords(response.data[props.recordsKey]);
    } catch (error) {
      setRecords([]);
      toast.error(error.data?.message, "Error while fetching records");
    }
  };

  const onSortClick = (e, esort_by, esort_order) => {
    e.preventDefault();
    dispatch(updateQueryParams(sortUpdated(esort_by, esort_order)));
  };

  const onSearch = (e, searchText) => {
    e.preventDefault();
    dispatch(updateQueryParams(searchUpdated(searchText)));
  };

  const onPerPageChange = (e, ePerPage) => {
    e.preventDefault();
    dispatch(updateQueryParams(perPageUpdated(ePerPage)));
  };

  const onPageChange = (e, ePage) => {
    e.preventDefault();
    dispatch(updateQueryParams(pageUpdated(ePage)));
  };

  const getHeaders = () => {
    return props.headers.map((header) => {
      return { ...defaultHeaderConfig, ...header };
    })
  }

  return (
    <Page
      uiPage={props.uiPage}
      breadcrumbs={props.breadcrumbs}
      className={props.className}
      contentTop={props.contentTop}
    >
      <PageContentWrapper contentHeading={props.contentHeading}>
        <Row>
          <Col>
            <TabularListingHeader
              page={page}
              per_page={per_page}
              onSearch={onSearch}
              onPerPageChange={onPerPageChange}
              onPageChange={onPageChange}
              paginationMeta={paginationMeta}
              tableHeaderActionsComponent={props.tableHeaderActionsComponent}
              filters={props.filters}
              searchBy={props.searchBy}
            />
            {paginationMeta.total_pages !== 0 ?
              <TabularListing
                headers={getHeaders()}
                rows={records}
                identifier="id"
                sort_by={sort_by || "id"}
                sort_order={sort_order}
                onSortClick={onSortClick}
              />
              :
              <Row>
                <span className="d-flex justify-content-center text-danger m-4">{"No Records Found ..!"}</span>
              </Row>
            }
            <TabularListingFooter
              page={page}
              per_page={per_page}
              onSearch={onSearch}
              onPerPageChange={onPerPageChange}
              onPageChange={onPageChange}
              paginationMeta={paginationMeta}
            />
          </Col>
        </Row>
      </PageContentWrapper>
    </Page>
  );
};

export default ListingPageComponent;
